let swipers = {
    advantages: globalSwipers.advantages
};

window.customAttachedImages = [];
window.warrantyImagesUploading = false;

function floatingBoxInit() {
    const $box = $('.js-articles-nav'),
        $boxWrapper = $('.js-float-box-wrapper');

    floatingBoxFloat($box, $boxWrapper);

    $(window).on('scroll resize', function() {
        floatingBoxFloat($box, $boxWrapper);
    });
}

function floatingBoxFloat($box, $boxWrapper) {
    if (checkResolution('md;lg')) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperHeight = $boxWrapper.outerHeight(),
            boxHegiht = $box.height(),
            scrollOffset = 30,

        // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
        boxStartScroll = windowTopOffset + scrollOffset,
        // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
        boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHegiht;

        // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
        // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
        // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
        // vtedy sa prida position fixed
        if (boxStartScroll > boxWrapperTopOffset && boxStartScroll < boxEndScroll) {
            if (!$box.hasClass('is-fixed')) {
                $box.css('top', scrollOffset);
                $box.addClass('is-fixed');
            }

        // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
        // posunie uplne na spodok wrapperu
        } else if (boxStartScroll > boxEndScroll) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxEndScroll - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }

        // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
        // uplne na vrch wrapperu
        } else if (boxStartScroll < boxWrapperTopOffset) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxWrapperTopOffset - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }
        }
    }
}

function blogGalleryCollapsibleHeightBuild() {
    $('.js-blog-gallery-collapsible').each(function() {
        const $collapsible = $(this),
            $trigger = $collapsible.siblings('.js-blog-gallery-collapsible-trigger'),
            $collapsibleContent = $collapsible.find('.js-blog-gallery-collapsible-content');

        let maxHeight = 325;

        if (checkResolution('cxs;xs')) {
            maxHeight = 250;
        }

        if ($collapsibleContent.outerHeight(true) > maxHeight) {
            if ($trigger.hasClass('open')) {
                $collapsible.addClass('resizing').css('max-height', $collapsibleContent.outerHeight(true));

                setTimeout(function() {
                    $collapsible.removeClass('resizing');
                }, 1);
            } else {
                $trigger.slideDown(500);
                $collapsible.addClass('collapsed');
            }
        } else {
            $collapsible.removeClass('collapsed');
            $trigger.slideUp(250).removeClass('open');
        }
    });
}

async function warrantyClaimCheckCaptcha(forceRevalidation = false) {
    return new Promise(async function(resolve) {
        const $imageUpload = $('.js-warranty-image-upload');

        if ($imageUpload.data('is-logged') || (!forceRevalidation && $imageUpload.data('has-captcha-validated'))) {
            return resolve(true);
        }

        $imageUpload.data('has-captcha-validated', false)

        const captchaToken = await getRecaptchaToken('warranty_upload')

        $.ajax({
            method: 'POST',
            url: $imageUpload.data('captcha-url'),
            data: {
                captchaToken: captchaToken
            },
            success: function(response) {
                if (response.status === true) {
                    $imageUpload.data('has-captcha-validated', true)
                    resolve(true)
                } else {
                    Eshop.alert($imageUpload.data('captcha-error'), { type: 'error' });
                    resolve(false)
                }
            },
            error: function() {
                Eshop.alert($imageUpload.data('captcha-error'), { type: 'error' });

                resolve(false)
            }
        });
    });
}

function changeDocumentNumber(input, url, callback = null) {
    var $form = $(input).parents('form');

    if (!$(input).val()) {
        $form.find('[name="order_product_ids[]"]').parents('.form-group').hide();
        $form.find('[name="product_names[]"]').parents('.form-group').show();

        $form.find('[name="order_product_ids[]"]').parents('.c-form__item').parent().hide();
        $form.find('[name="product_names[]"]').parents('.c-form__item').parent().show();
    } else {
        Form.fetchDependentOptions(input, 'order_product_ids[]', url, {
            callback: function() {
                $form.find('[name="order_product_ids[]"]').parents('.form-group').show();
                $form.find('[name="product_names[]"]').parents('.form-group').hide();

                $form.find('[name="order_product_ids[]"]').parents('.c-form__item').parent().show();
                $form.find('[name="product_names[]"]').parents('.c-form__item').parent().hide();

                if (callback !== null) {
                    callback(input);
                }

                $form.find('[name="order_product_ids[]"]').multiselect('rebuild');
            }
        });
    }
}

function changeDocumentNumberCallback(input) {
    var $form = $(input).parents('form');
    window.orderProductCount = $form.find('[name="order_product_ids[]"]:first').find('option').length;
    $form.find('[name="order_product_ids[]"]').prepend('<option value="" selected>' + window.wholeOrderTranslated + '</option>');
    $form.find('[name="order_product_ids[]"]').trigger('change');

    removeDuplicatedProductBlocks();
}

function removeDuplicatedProductBlocks() {
    $('.js-product-block').each(function (index, el) {
        const attr = $(el).data('first-block');

        if (attr === null) {
            $(el).remove();
        }
    });
}

function orderProductChange(e) {
    const $this = $(this);
    const $addProductLink = $('.js-add-product-block');

    if ($this.val() === "" || $this.val() === null) {
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').attr('type', 'hidden');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').val("1");
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').siblings('label').hide();
        $addProductLink.hide();

        $('.js-product-block').data('first-block', null);
        $this.parents('.js-product-block').data('first-block', '1');
        removeDuplicatedProductBlocks();
    } else {
        // const quantity = $this.find('option:selected').data('quantity');

        $this.parents('.js-product-block').find('[name="product_quantities[]"]').attr('type', 'input');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').val('1');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').siblings('label').show();

        if ($('.js-product-block').length < window.orderProductCount) {
            $addProductLink.show();
        }
    }
}

// kvoli vyhladavaniu, aby diaktiritka bola irelevantna
const addMultiselectCustomData = ($selects) => {
    $selects.each(function () {
        const $select = $(this);
        const $options = $select.find('option');
        const $multiselect = $select.next().find('.dropdown-menu');

        $options.each(function () {
            const $option = $(this);
            const value = $option.val();
            const $multiselectInput = $multiselect.find('input[value="' + value + '"]');
            const $multiselectInputLabel = $multiselectInput.closest('label');

            if (!$multiselectInputLabel.find('.c-normalized').length) {
                const normalizedText = $multiselectInputLabel.text().normalize("NFD").replace(/[\u0300-\u036f]/g, "")

                $multiselectInputLabel.append(`<span class="hidden c-normalized">${normalizedText}</span>`);
            }
        });
    });
}

function buildSelects() {
    $('#claim-form').find('select').each(function() {
        if ($(this).hasClass('has-multiselect-initialized')) {
            return;
        }

        const $multiselect = $(this);
        const filterPlaceholder = $multiselect.data('filter-placeholder');
        const placeholder = $multiselect.data('placeholder');
        const hasFilter = $multiselect.data('has-filter')

        $multiselect.multiselect({
            templates: {
                button: `
                    <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                        <span class="multiselect-selected-text"></span>
                        <i aria-hidden="true" class="ico ico-chevron-down"></i>
                    </button>
                `,
                filter: `
                    <li class="multiselect-item filter">
                        <div class="input-group">
                            <input class="c-form__input is-sm multiselect-search" type="text">
                        </div>
                    </li>
                `,
                filterClearBtn: ''
            },
            buttonClass: 'c-form__input',
            enableHTML: true,
            enableCaseInsensitiveFiltering: hasFilter,
            filterBehavior: 'text',
            nonSelectedText: placeholder,
            filterPlaceholder: filterPlaceholder,
            onDropdownShown: function(event) {
                const searchInput = event.target.querySelector('input.multiselect-search')

                if (searchInput) {
                    searchInput.focus()
                }
            }
        });

        $multiselect.addClass('has-multiselect-initialized');
    });

    requestAnimationFrame(() => {
        addMultiselectCustomData($('#claim-form').find('select[data-has-filter]'))
    })
}

$(function() {
    checkSliders(swipers);

    $(window).on('resize', function () {
        checkSliders(swipers);
    });

    if ($('.js-float-box-wrapper').length) {
        floatingBoxInit();
    }

    blogGalleryCollapsibleHeightBuild();

    $('.js-blog-gallery-collapsible-trigger').on('click', function() {
        const $trigger = $(this),
            $collapsible = $trigger.siblings('.js-blog-gallery-collapsible'),
            $collapsibleContent = $collapsible.find('.js-blog-gallery-collapsible-content'),
            $galleryWrapper = $collapsible.closest('.js-blog-gallery');

        if ($trigger.hasClass('open')) {
            $trigger.removeClass('open');
            $collapsible.addClass('collapsed').css('max-height', '');

            if ($galleryWrapper.offset().top < $(window).scrollTop()) {
                $galleryWrapper.slideHere(30, 300)
            }
        } else {
            $trigger.addClass('open');
            $collapsible.removeClass('collapsed').css('max-height', $collapsibleContent.outerHeight(true));
        }
    });

    $(".js-blog-gallery").lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: ".js-lightbox",
            galleryId: 1
        })
    );

    $(window).on('resize', function() {
        blogGalleryCollapsibleHeightBuild();
    });

    $('.l-articles').off('click', '.js-articles-menu');

    $('.l-articles')
        .on('click', '.js-articles-menu', function() {
            var $nav = $('.js-articles-nav');

            $nav.slideToggle(250);
        });

    $('.js-custom-form-account-claim').validate({
        rules: {
            customer_email: {
                email: true
            },
            customer_post_code: {
                number: true
            }
        },
        errorPlacement: function(error, element) {
            if (element.prop("tagName") === 'SELECT') {
                error.insertAfter(element.siblings(".btn-group"));
            } else if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            if (window.warrantyImagesUploading) {
                return false;
            }

            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');
            $(form).find('[name="custom_attached_images"]').val(JSON.stringify(window.customAttachedImages));

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });

    if ($('.js-warranty-image-upload').length) {
        const csrfToken = $('.js-custom-form-account-claim').find('input[name="_csrfToken"]').val();
        const saveUrl = $('.js-warranty-image-upload').data('save-url');

        $('.js-warranty-image-upload').kendoUpload({
            async: {
                saveUrl: saveUrl,
                autoUpload: false
            },
            validation: {
                allowedExtensions: ['.jpg', '.jpeg', '.png'],
            },
            select: function () {
                warrantyClaimCheckCaptcha().then((result) => {
                    if (result) {
                        this.upload()
                    }
                })
            },
            upload: function (e) {
                $('.js-custom-form-account-claim').find('[type="submit"]').prop('disabled', true);
                window.warrantyImagesUploading = true;

                e.data = {
                    _csrfToken: csrfToken
                };
            },
            success: function(data) {
                if (data.response.success) {
                    window.customAttachedImages.push(data.response.success);
                } else {
                    Eshop.alert($('.js-warranty-image-upload').data('generic-error'), {'type': 'danger'});
                }
            },
            error: function() {
                warrantyClaimCheckCaptcha(true);
                Eshop.alert($('.js-warranty-image-upload').data('generic-error'), {'type': 'danger'});
            },
            complete: function() {
                window.warrantyImagesUploading = false;
                $('.js-custom-form-account-claim').find('[type="submit"]').prop('disabled', false);
            }
        });
    }

    if (window.isReturn) {
        $('[name="order_product_ids[]"]').change(orderProductChange);

        // duplicate product blocks
        $('.js-add-product-block').click(function (e) {
            e.preventDefault();

            const $lastBlock = $('.js-product-block:last');

            $lastBlock.find('select').each(function (index, el) {
                const $selectEl = $(el);
                const $parent = $selectEl.parent();

                $selectEl.multiselect('destroy');
                $selectEl.removeClass('has-multiselect-initialized');
                $selectEl.insertAfter($parent);

                $parent.remove();
            });

            const $duplicatedBlock = $lastBlock.clone();
            $duplicatedBlock.find('option').each(function (index, el) {
                if ($(el).val() == '') {
                    $(el).remove();
                }
            });

            // clear existing input values
            $duplicatedBlock.find('input,textarea').each(function (index, el) {
                $(el).val('');
            })

            $('.js-product-block:last').after($duplicatedBlock);
            $('.js-product-block:last').data('first-block', null);

            if (window.orderProductCount) {
                $('.js-product-block:last').find('[name="order_product_ids[]"]').change(orderProductChange);

                if ($('.js-product-block').length < window.orderProductCount) {
                    $('.js-add-product-block').show();
                } else {
                    $('.js-add-product-block').hide();
                }
            }

            buildSelects();
        })
    }

    buildSelects();

    $('.js-pickup-method-input').on('change', function() {
        const $selectedOption = $(this).find('option:selected');
        const moduleId = $selectedOption.data('module-id');
        const $form = $(this).closest('form');

        $form.find('.js-custom-pickup-module-id-holder').toggleClass('hidden', moduleId !== 172);

        if (moduleId == 172) {
            $form.find('.js-custom-pickup-module-id-input').multiselect('disable');

            $.get('/sps-parcelshops', {}, function(data) {
                // object.branches is object where key is id and value is name, add them to select as options
                var options = '';
                $.each(data.branches, function(key, value) {
                    options += '<option value="' + key + '">' + value + '</option>';
                });

                $form.find('.js-custom-pickup-module-id-input').html(options);
                $form.find('.js-custom-pickup-module-id-input').multiselect('rebuild');
                $form.find('.js-custom-pickup-module-id-input').multiselect('enable');
            });
        }

        $form.find('.js-custom-pickup-module-id-input').multiselect('disable');
    });
});
